import { Link } from 'react-router-dom';

const LogoBox = () => {
  return (
    <Link to="/" style={{ textDecoration: 'none' }}>
      <div className='flex space-x-1.5 items-center'>
        <div className='w-8 h-8 rounded-1 bg-white'>
          <img className='!w-full !h-full' src='/logo.svg' alt="logo" />
        </div>
        <p className='font-semibold text-[#0a4081] m-0'>Vietrro</p>
      </div>
    </Link>
  );
};

export default LogoBox;
